'use client';

import { Chip } from '@common/components';
import useEmblaCarousel from 'embla-carousel-react';

import type { POLICY_CASE_TYPE } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { ROUTES } from '@/constants';
import { gtmDatasets } from '@/utils/analytics/gtm';

interface CaseTypeSwiperProps {
  caseType?: string;
  caseTypeList: {
    caseType: POLICY_CASE_TYPE | 'ALL';
    name: string;
  }[];
}

export const CaseTypeSwiper = ({
  caseType,
  caseTypeList,
}: CaseTypeSwiperProps) => {
  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps',
  });

  return (
    <div
      className="scrollbar-hide w-full overflow-x-scroll py-8 pl-20"
      ref={emblaRef}
    >
      <div className="flex gap-6">
        {caseTypeList.map((caseTypeListItem) => (
          <div
            key={caseTypeListItem.caseType}
            className="w-fit flex-[0_0_auto] last:mr-20"
          >
            <CustomLink
              replace
              href={ROUTES.RECOMMEND_POLICY_SITUATION_MAIN.pathname({
                caseType: caseTypeListItem.caseType,
              })}
              {...gtmDatasets.clickTab({
                tab_name: caseTypeListItem.name,
              })}
            >
              <Chip
                checked={caseTypeListItem.caseType === caseType}
                className="flex h-34 select-none items-center typo-body4"
                theme="primary"
              >
                {caseTypeListItem.name}
              </Chip>
            </CustomLink>
          </div>
        ))}
      </div>
    </div>
  );
};
